import { ExplorerAssistantConversationService } from '@om1/falcon-api'
import { handleApiError } from '@om1/falcon-api/utils'
import { call, put } from 'redux-saga/effects'
import { explorerAssistantConversationActions } from '../state/explorer-assistant-conversation-actions'

export function createDeleteExplorerAssistantConversationSaga() {
    return function* (action: ReturnType<typeof explorerAssistantConversationActions.deleteConversation>) {
        try {
            yield call(ExplorerAssistantConversationService.deleteExplorerAssistantConversationIdDelete, {
                id: action.payload.id
            })
            yield put(explorerAssistantConversationActions.deleteConversationSuccess(action.payload))
        } catch (error: any) {
            yield handleApiError(error)
        } finally {
            yield put(explorerAssistantConversationActions.setConversationsLoading(false))
        }
    }
}

export type DeleteExplorerAssistantConversationSaga = ReturnType<typeof createDeleteExplorerAssistantConversationSaga>
